/**
 * Lemich Editorial — Scroll Reveal & Refined Interactions
 * - IntersectionObserver para reveal en viewport
 * - Header scroll state
 * - Smooth scroll para anchors internos
 * - Parallax sutil en hero
 */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    initScrollReveal();
    initHeaderScroll();
    initSmoothScroll();
    if (!prefersReducedMotion) initParallax();
  }

  function initScrollReveal() {
    var revealItems = document.querySelectorAll('.reveal, .lemich-editorial-block');
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      // Mostrar todo, sin animación
      revealItems.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    revealItems.forEach(function (el) { observer.observe(el); });
  }

  function initHeaderScroll() {
    var header = document.getElementById('lemich-header');
    if (!header) return;
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > 24) header.classList.add('is-scrolled');
          else header.classList.remove('is-scrolled');
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  function initParallax() {
    var heroImg = document.querySelector('.hero-editorial__image');
    if (!heroImg) return;
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y < window.innerHeight) {
            heroImg.style.transform = 'translateY(' + (y * 0.3) + 'px) scale(' + (1 + y * 0.0001) + ')';
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
